import { render } from "./AppDocuments.vue?vue&type=template&id=756acdda&scoped=true"
import script from "./AppDocuments.vue?vue&type=script&lang=js"
export * from "./AppDocuments.vue?vue&type=script&lang=js"

import "./AppDocuments.vue?vue&type=style&index=0&id=756acdda&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756acdda"]])

export default __exports__